import { estadoLegajoInfo, type EstadoLegajoInfo, type TonoEstado } from '@lib/estado-legajo';

const TONO_CLASS: Record<TonoEstado, string> = {
  success: 'status status-success',
  info: 'status status-info',
  warning: 'status status-warning',
  error: 'status status-error',
  neutral: 'status',
};

/**
 * Badge del estado del legajo: muestra el label claro del catálogo, con color
 * por tono y la descripción como tooltip nativo al pasar el mouse por encima.
 * Único punto donde se pinta el estado — usarlo en vez del estado crudo.
 *
 * `info` es para un estado que parte del legajo pero no es uno de sus estados
 * (ej. "Bloqueado" o "Espera activación titular" del Reporte de padrón): se pinta
 * igual, con el label y el tono que traiga.
 */
export function EstadoLegajoBadge({
  estado,
  size = 11,
  info: infoPropia,
}: {
  estado: string;
  size?: number;
  info?: EstadoLegajoInfo;
}) {
  const info = infoPropia ?? estadoLegajoInfo(estado);
  const neutral = info.tono === 'neutral';
  return (
    <span
      className={TONO_CLASS[info.tono]}
      title={info.descripcion}
      style={{
        fontSize: size,
        cursor: 'help',
        whiteSpace: 'nowrap',
        // La clase .status fuerza lowercase (píldoras viejas); acá queremos los
        // labels del catálogo tal cual (capitalización y "Binary" propios).
        textTransform: 'none',
        ...(neutral
          ? { background: 'var(--color-surface-accent, #eef1f5)', color: 'var(--color-element-mid)' }
          : {}),
      }}
    >
      {info.label}
    </span>
  );
}
